import {
    createPrettyLogger,
    type CreatePrettyLoggerOptions,
} from './factories';
import type { PrettyLogger, PrettyLoggerFn } from './types';

declare global {
    interface Console {
        pretty: PrettyLogger;
        debug$: PrettyLoggerFn;
        info$: PrettyLoggerFn;
        log$: PrettyLoggerFn;
        warn$: PrettyLoggerFn;
        error$: PrettyLoggerFn;
    }
}

export function init(options?: CreatePrettyLoggerOptions) {
    console.pretty = createPrettyLogger(options);
    console.debug$ = console.pretty.debug;
    console.info$ = console.pretty.info;
    console.log$ = console.pretty.log;
    console.warn$ = console.pretty.warn;
    console.error$ = console.pretty.error;
}
